import { styles } from './UiKitProgressLine.styles';

export interface UiKitProgressLineProps {
  className?: string;
  current: number;
  target: number;
}

export function UiKitProgressLine({
  className,
  current,
  target
}: UiKitProgressLineProps) {
  const slots = styles();
  const progressPercentage = Math.round((current * 100) / target);

  return (
    <div className={slots.base({ className })}>
      <div
        className={slots.line()}
        style={{ width: `${progressPercentage}%` }}
      ></div>
    </div>
  );
}
